import { Group, Image } from '@mantine/core';
import { NavLink } from 'react-router-dom';

export const AdminLogo = ({ className, width = 150 }: { width?: number; className?: string }) => {
  const isLocalMode = import.meta.env.VITE_MODE === 'local';

  // 本地部署版，点击不跳转
  if (isLocalMode)
    return (
      <Group justify="center" gap={8} className={className}>
        <Image src={'/logo-onprem.png'} w={width}></Image>
      </Group>
    );

  return (
    <NavLink to={import.meta.env.VITE_SUPPORT_WEBSITE}>
      <Group justify="center" gap={8} my={40}>
        <Image src={'/logo-cloud.png'} w={150}></Image>
      </Group>
    </NavLink>
  );
};
